(() => {
  if (customElements.get('cart-shoe-tree-options')) return;

  class CartShoeTreeOptions extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.addEventListener('change', event => {
        if (event.target.matches('[data-cart-upsell-variant]')) this.selectVariant(event.target);
      }, options);
      this.addEventListener('variant:add', () => this.closest('x-modal')?.hide(), options);
      const selected = this.querySelector('[data-cart-upsell-variant]:checked');
      if (selected) this.selectVariant(selected);
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    selectVariant(input) {
      this.querySelector('input[name="id"]').value = input.value;
      this.querySelector('[data-cart-upsell-size]').textContent = input.dataset.size;
      this.querySelector('[data-cart-upsell-current]').textContent = input.dataset.price;
      this.querySelector('[data-cart-upsell-button-price]').textContent = input.dataset.price;
      const compare = this.querySelector('[data-cart-upsell-compare]');
      compare.hidden = !input.dataset.comparePrice;
      this.querySelector('[data-cart-upsell-compare-amount]').textContent = input.dataset.comparePrice;
    }
  }

  customElements.define('cart-shoe-tree-options', CartShoeTreeOptions);
})();
